import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  }
});
